import { defineStore } from "pinia";

export const useThemeStore = defineStore("admin_theme", {
  state: () => ({
    /** 是否为深色模式 */
    isDarkMode: false,
  }),
  actions: {
    /**
     * 切换主题模式（深色/浅色）
     * 自动更新 DOM class 并同步 toaster 主题
     */
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
      this.applyTheme();
    },
    /**
     * 将当前主题状态应用到 document.documentElement
     */
    applyTheme() {
      if (typeof document !== "undefined") {
        if (this.isDarkMode) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      }
    },
  },
  persist: {
    key: "admin_theme",
    storage: localStorage,
    paths: ["isDarkMode"],
  },
});
